import { connect } from 'react-redux';
import {
  getLabels,
  getLocation,
  getMetainf,
  getProjectOriginalZoneId,
  getProjectZoneId,
  getUnitsExecutionState,
} from '../../../reducers/analyticsApp';
import EventPreview from '../../../components/dashboards/preview/EventPreview';
import { isValidFormula, isValidSymbols } from '../../../components/event/EventFormula';

const mapStateToProps = (state, { unit }) => {
  const unitExecute = getUnitsExecutionState(state)[unit.id];
  const { options } = unit.compose.events;
  const isValidF =
    isValidFormula(options.enteredFormula, unitExecute.events) &&
    isValidSymbols(options.enteredFormula);
  const validOptions = isValidF ? options : { ...options, enteredFormula: '' };

  return {
    result: unitExecute.events || [],
    executeTime: unitExecute.executeTime,
    timezone: getProjectZoneId(state),
    metainf: getMetainf(state),
    executionEvents: unitExecute.events,
    options: validOptions,
    originalZoneId: getProjectOriginalZoneId(state),
    zoneId: getProjectZoneId(state),
    labels: getLabels(state),
    location: getLocation(state),
    unit,
  };
};

export default connect(mapStateToProps)(EventPreview);
